import KeyMirror from "key-mirror";



export const GSTIN_REGEX = /([0-3][0-9])([A-Z]{5})([0-9]{4})[A-Z]([0-9]|[A-Z])Z([0-9]|[A-Z])/i;

export const COMPANY_LOS_ACTIONS = new KeyMirror({

    FETCH_DATA_SYNC_REQUEST: null,
    FETCHED_DATA_SYNC_REQUEST: null,
    FAILED_FETCH_DATA_SYNC_REQUEST: null,

    FETCH_COMPANY_SYNC_REQUEST_PROCESS_REJECT: null,
    FETCHED_COMPANY_SYNC_REQUEST_PROCESS_REJECT: null,
    FAILED_FETCH_COMPANY_SYNC_REQUEST_PROCESS_REJECT: null,

    SET_TENOR: null,
    FETCH_COMPANY_SYNC_REQUEST_COUNT: null,
    FETCHED_COMPANY_SYNC_REQUEST_COUNT: null,
    FAILED_FETCH_COMPANY_SYNC_REQUEST_COUNT: null,

    UPDATE_TENOR: null,
    UPDATING_TENOR: null,

    FETCH_COMPANY_SYNC_REQUEST: null,
    FETCHED_COMPANY_SYNC_REQUEST: null,
    FAILED_FETCH_COMPANY_SYNC_REQUEST: null,

    FETCH_COMPANY_LOS_PROFILE_LIST: null,
    FETCHED_COMPANY_LOS_PROFILE_LIST: null,
    FAILED_FETCH_COMPANY_LOS_PROFILE_LIST: null,

    CREATE_COMPANY_LOS_PROFILE: null,
    CREATED_COMPANY_LOS_PROFILE: null,
    FAILED_CREATE_COMPANY_LOS_PROFILE: null,

    FETCH_COMPANY_LOS_PROFILE: null,
    FETCHED_COMPANY_LOS_PROFILE: null,
    FAILED_FETCH_COMPANY_LOS_PROFILE: null,

    FETCH_COMPANY_LOS_DETAIL: null,
    FETCHED_COMPANY_LOS_DETAIL: null,
    FAILED_FETCH_COMPANY_LOS_DETAIL: null,
    
    FETCH_DB_RISK_CONTROL_DETAIL: null,
    FETCHED_DB_RISK_CONTROL_DETAIL: null,
    FAILED_FETCH_DB_RISK_CONTROL_DETAIL: null,
    
    UPDATE_DB_RISK_CONTROL_DETAIL: null,
    UPDATED_DB_RISK_CONTROL_DETAIL: null,
    FAILED_UPDATE_DB_RISK_CONTROL_DETAIL: null,

    FETCH_COMPANY_LOS_ERPS: null,
    FETCHED_COMPANY_LOS_ERPS: null,
    FAILED_FETCH_COMPANY_LOS_ERPS: null,

    FETCH_COMPANY_LOS_BANKING_FACILITIES: null,
    FETCHED_COMPANY_LOS_BANKING_FACILITIES: null,
    FAILED_FETCH_COMPANY_LOS_BANKING_FACILITIES: null,

    FETCH_COMPANY_LOS_ANNUAL_TURNOVERS: null,
    FETCHED_COMPANY_LOS_ANNUAL_TURNOVERS: null,
    FAILED_FETCH_COMPANY_LOS_ANNUAL_TURNOVERS: null,

    FETCH_COMPANY_LOS_BRANDS: null,
    FETCHED_COMPANY_LOS_BRANDS: null,
    FAILED_FETCH_COMPANY_LOS_BRANDS: null,

    FETCH_COMPANY_LOS_SCHEMES: null,
    FETCHED_COMPANY_LOS_SCHEMES: null,
    FAILED_FETCH_COMPANY_LOS_SCHEMES: null,

    FETCH_COMPANY_LOS_ATTACHMENTS: null,
    FETCHED_COMPANY_LOS_ATTACHMENTS: null,
    FAILED_FETCH_COMPANY_LOS_ATTACHMENTS: null,

    UPDATE_COMPANY_LOS_PROFILE: null,
    UPDATED_COMPANY_LOS_PROFILE: null,
    FAILED_UPDATE_COMPANY_LOS_PROFILE: null,

    UPDATE_COMPANY_LOS_DETAIL: null,
    UPDATED_COMPANY_LOS_DETAIL: null,
    FAILED_UPDATE_COMPANY_LOS_DETAIL: null,

    UPDATE_COMPANY_LOS_ATTACHMENTS: null,
    UPDATED_COMPANY_LOS_ATTACHMENTS: null,
    FAILED_UPDATE_COMPANY_LOS_ATTACHMENTS: null,

    UPLOAD_COMPANY_LOS_ATTACHMENT: null,
    UPLOADED_COMPANY_LOS_ATTACHMENT: null,
    FAILED_UPLOAD_COMPANY_LOS_ATTACHMENT: null,

    UPDATE_COMPANY_LOS_SPOC_USER: null,
    UPDATED_COMPANY_LOS_SPOC_USER: null,
    FAILED_UPDATE_COMPANY_LOS_SPOC_USER: null,

    UPDATE_COMPANY_DISBURSAL_ACCOUNT: null,
    UPDATED_COMPANY_DISBURSAL_ACCOUNT: null,
    FAILED_UPDATE_COMPANY_DISBURSAL_ACCOUNT: null,

    UPDATE_COMPANY_LOS_ERPS: null,
    UPDATED_COMPANY_LOS_ERPS: null,
    FAILED_UPDATE_COMPANY_LOS_ERPS: null,

    UPDATE_COMPANY_LOS_BANKING_FACILITIES: null,
    UPDATED_COMPANY_LOS_BANKING_FACILITIES: null,
    FAILED_UPDATE_COMPANY_LOS_BANKING_FACILITIES: null,

    UPDATE_COMPANY_LOS_ANNUAL_TURNOVERS: null,
    UPDATED_COMPANY_LOS_ANNUAL_TURNOVERS: null,
    FAILED_UPDATE_COMPANY_LOS_ANNUAL_TURNOVERS: null,

    UPDATE_COMPANY_LOS_BRANDS: null,
    UPDATED_COMPANY_LOS_BRANDS: null,
    FAILED_UPDATE_COMPANY_LOS_BRANDS: null,

    UPDATE_COMPANY_LOS_SCHEMES: null,
    UPDATED_COMPANY_LOS_SCHEMES: null,
    FAILED_UPDATE_COMPANY_LOS_SCHEMES: null,

    FETCH_INVOICE_JOB: null,
    FETCHED_INVOICE_JOB: null,
    FAILED_FETCH_INVOICE_JOB: null,
    CLEAR_INVOICE_JOB: null,

    FETCH_CREATE_INVOICE_JOB: null,
    FETCHED_CREATE_INVOICE_JOB: null,
    FAILED_FETCH_CREATE_INVOICE_JOB: null,

    FETCH_UPDATE_INVOICE_JOB: null,
    FETCHED_UPDATE_INVOICE_JOB: null,
    FAILED_FETCH_UPDATE_INVOICE_JOB: null,
    CLEAR_UPDATE_INVOICE_JOB: null,

    FETCH_ALL_INVOICE_JOB: null,
    FETCHED_ALL_INVOICE_JOB: null,
    FAILED_FETCH_ALL_INVOICE_JOB: null,

    UPDATE_INVOICE_JOB_STATUS: null,

    FETCH_INVOICE_CARDS: null,
    FETCHED_INVOICE_CARDS: null,
    FAILED_FETCH_INVOICE_CARDS: null,

    FETCH_MARK_JOB_PENDING: null,
    FETCHED_MARK_JOB_PENDING: null,
    FAILED_FETCH_MARK_JOB_PENDING: null,

    FETCH_FINAL_SUBMISSION: null,
    FETCHED_FINAL_SUBMISSION: null,
    FAILED_FETCH_FINAL_SUBMISSION: null,

    FETCH_REMOVE_INVOICE: null,
    FETCHED_REMOVE_INVOICE: null,
    FAILED_FETCH_REMOVE_INVOICE: null,

    FETCH_FEE: null,
    FETCHED_FEE: null,
    FAILED_FETCH_FEE: null,

    FETCH_FEE_MASTER: null,
    FETCHED_FEE_MASTER: null,
    FAILED_FETCH_FEE_MASTER: null,

    FETCH_ADD_FEE: null,
    FETCHED_ADD_FEE: null,
    FAILED_FETCH_ADD_FEE: null,

    DELETE_ANNUAL_TURNOVER: null,
    DELETED_ANNUAL_TURNOVER: null,
    FAILED_DELETE_ANNUAL_TURNOVER: null,

    DELETE_BRANDS: null,
    DELETED_BRANDS: null,
    FAILED_DELETE_BRANDS: null,

    DELETE_ERP_DETAILS: null,
    DELETED_ERP_DETAILS: null,
    FAILED_DELETE_ERP_DETAILS: null,

    DELETE_BANKING_FACILITY: null,
    DELETED_BANKING_FACILITY: null,
    FAILED_DELETE_BANKING_FACILITY: null,

    FETCH_TENOR_LIST: null,
    FETCHED_TENOR_LIST: null,
    FAILED_FETCH_TENOR_LIST: null,

    FETCH_MARGIN_LIST: null,
    FETCHED_MARGIN_LIST: null,
    FAILED_FETCH_MARGIN_LIST: null,

    FETCH_INTEREST_LIST: null,
    FETCHED_INTEREST_LIST: null,
    FAILED_FETCH_INTEREST_LIST: null,

    FETCH_CASHBACK_LIST: null,
    FETCHED_CASHBACK_LIST: null,
    FAILED_FETCH_CASHBACK_LIST: null,

    FETCH_WITHHOLD_PERC_MASTER: null,
    FETCHED_WITHHOLD_PERC_MASTER: null,
    FAILED_FETCH_WITHHOLD_PERC_MASTER: null,

    CREATE_COMPANY_SELLER_SCHEME: null,
    CREATED_COMPANY_SELLER_SCHEME: null,
    FAILED_CREATE_COMPANY_SELLER_SCHEME: null,

    UPDATE_COMPANY_SELLER_SCHEME: null,
    UPDATED_COMPANY_SELLER_SCHEME: null,
    FAILED_UPDATE_COMPANY_SELLER_SCHEME: null,

    FETCH_COMPANY_SELLER_SCHEME: null,
    FETCHED_COMPANY_SELLER_SCHEME: null,
    FAILED_FETCH_COMPANY_SELLER_SCHEME: null,

    CREATE_COMPANY_SELLER_SCHEME_MAPPING: null,
    CREATED_COMPANY_SELLER_SCHEME_MAPPING: null,
    FAILED_CREATE_COMPANY_SELLER_SCHEME_MAPPING: null,

    UPDATE_COMPANY_SELLER_SCHEME_MAPPING: null,
    UPDATED_COMPANY_SELLER_SCHEME_MAPPING: null,
    FAILED_UPDATE_COMPANY_SELLER_SCHEME_MAPPING: null,

    FETCH_COMPANY_SELLER_SCHEME_MAPPING: null,
    FETCHED_COMPANY_SELLER_SCHEME_MAPPING: null,
    FAILED_FETCH_COMPANY_SELLER_SCHEME_MAPPING: null,

    CREATE_AGREEMENT: null,
    CREATED_AGREEMENT: null,
    FAILED_CREATE_AGREEMENT: null,

    FETCH_COMPANY_AGREEMENT: null,
    FETCHED_COMPANY_AGREEMENT: null,
    FAILED_FETCH_COMPANY_AGREEMENT: null,

    UPDATE_AGREEMENT: null,
    UPDATED_AGREEMENT: null,
    FAILED_UPDATE_AGREEMENT: null,

    FETCH_COMPANY_AGREEMENT_DETAIL: null,
    FETCHED_COMPANY_AGREEMENT_DETAIL: null,
    FAILED_FETCH_COMPANY_AGREEMENT_DETAIL: null,

    GENERATE_PDF: null,
    GENERATED_PDF: null,
    FAILED_GENERATE_PDF: null,

    UPDATE_COMPANY_PROFILE_ADDRESS: null,
    UPDATED_COMPANY_PROFILE_ADDRESS: null,
    FAILED_UPDATE_COMPANY_PROFILE_ADDRESS: null,

    VALIDATE_COMPANY_DOCUMENT: null,
    VALIDATED_COMPANY_DOCUMENT: null,
    FAILED_VALIDATE_COMPANY_DOCUMENT: null,

    INVALIDATE_COMPANY_DOCUMENT: null,
    INVALIDATED_COMPANY_DOCUMENT: null,
    FAILED_INVALIDATE_COMPANY_DOCUMENT: null,

    ADD_RETAILER_MAPPING: null,
    ADDED_RETAILER_MAPPING: null,
    FAILED_ADD_RETAILER_MAPPING: null,

    FETCH_RETAILER_MAPPING: null,
    FETCHED_RETAILER_MAPPING: null,
    FAILED_FETCH_RETAILER_MAPPING: null,
    FETCH_SELLER_LEDGER_MASTER: null,
    FETCHED_SELLER_LEDGER_MASTER: null,
    FAILED_FETCH_SELLER_LEDGER_MASTER: null,

    FETCH_COMPANY_VISIBILITY_SHEET_DATA: null,
    FETCHED_COMPANY_VISIBILITY_SHEET_DATA: null,
    FAILED_FETCH_COMPANY_VISIBILITY_SHEET_DATA: null,

    UPDATE_SELLER_LEDGER_MASTER: null,
    UPDATED_SELLER_LEDGER_MASTER: null,
    FAILED_UPDATE_SELLER_LEDGER_MASTER: null,

    FETCH_DEALERS_FROM_GSTIN: null,
    FETCHED_DEALERS_FROM_GSTIN:null,
    FAILED_FETCH_DEALERS_FROM_GSTIN : null,

    FETCH_CASES_AS_SELLER: null,
    FETCHED_CASES_AS_SELLER: null,
    UPDATE_DOCUMENT_STATUS: null,
    UPDATED_DOCUMENT_STATUS: null,
    FAILED_UPDATE_DOCUMENT_STATUS : null,

    FETCH_CAM_ENGINE: null,
    FETCHED_CAM_ENGINE: null,
    FAILED_FETCH_CAM_ENGINE: null,

    FETCH_CAM_ENGINE_COMMENTS: null,
    FETCHED_CAM_ENGINE_COMMENTS: null,
    FAILED_FETCH_CAM_ENGINE_COMMENTS: null,
    
    FETCH_CAM_ENGINE_STATUS_LOGS: null,
    FETCHED_CAM_ENGINE_STATUS_LOGS: null,
    FAILED_FETCH_CAM_ENGINE_STATUS_LOGS: null,
    
    
    FETCH_PORTFOLIO_VIEW: null,
    FETCHED_PORTFOLIO_VIEW: null,
    FAILED_FETCH_PORTFOLIO_VIEW: null,

    
    FETCH_BOUNCE_CHARGES: null,
    FETCHED_BOUNCE_CHARGES: null,
    FAILED_FETCH_BOUNCE_CHARGES: null,

    FETCH_PRE_PAYMENT_CHARGES: null,
    FETCHED_PRE_PAYMENT_CHARGES: null,
    FAILED_FETCH_PRE_PAYMENT_CHARGES: null,


    FETCH_BOUNCE_CHARGES_MASTER: null,
    FETCHED_BOUNCE_CHARGES_MASTER: null,
    FAILED_FETCH_BOUNCE_CHARGES_MASTER : null,

    FETCH_PRE_PAYMENT_CHARGES_MASTER: null,
    FETCHED_PRE_PAYMENT_CHARGES_MASTER: null,
    FAILED_FETCH_PRE_PAYMENT_CHARGES_MASTER: null

    
});

export const STATE_STATUS = KeyMirror({
    UNFETCHED: null,
    FETCHING: null,
    FETCHED: null,
    FETCH_FAILED: null,
    UPDATING: null,
    UPDATED: null,
    UPDATE_FAILED: null,
    INSTANTIATED: null,
    CREATING: null,
    CREATED: null,
    CREATE_FAILED: null,
    UPLOADING: null,
    UPLOADED: null,
    UPLOAD_FAILED: null,
    IDLE: null,
    ENGAGED: null
});

export const VISIBILITY_REMARKS = new KeyMirror({
    "Vintage under 6 months": null,
    "Limit basis sales < 50K": null,
    "No positive sales month in last 12 months": null,
    "Net Sales in last 12 months <= 0": null,
    "Sales Months < 3 in last 6 months": null,
    "Sales Months < 40% in last 12 months": null,
    "Severe Bounces": null,
    "Severe Overdues": null,
    "Overdue O/S for <tenor_plus_60> Days": null,
    "Wrong GSTIN": null,
    "No GSTIN": null
});